<template>
  <div class="container pt-24">
    <!-- Desktop Version -->
    <div class="hidden md:flex">
      <div class="whychoose-grid gap-x-6 gap-y-16">

        <!-- Main Why Choose Us Header -->
        <div class="flex justify-center col-span-full">
          <div class="flex flex-col text-center">
            <div class="responsive-title-2 section-title__header">
              {{ t('whyChoose.header') }}
            </div>
            <p class="cardcolor__title-body pt-6 responsive-body-medium">
              {{ t('whyChoose.body') }}
            </p>
          </div>
        </div>

        <!-- Cards -->
        <div
            v-for="(item, index) in whyChooseItems"
            :key="item.id"
            :class="item.gridClass"
        >
          <div class="flex flex-col relative">
            <!-- Number Badge -->
            <div class="absolute">
          <span class="bg-white spanNumber">
            {{ (index + 1).toString().padStart(2, '0') }}
          </span>
            </div>

            <!-- Card Content -->
            <div :class="item.cardClass">
              <div class="flex flex-col gap-y-3 items-start">
                <img 
                    :src="item.icon" 
                    alt="icon" 
                    class="imagePlaceholder" 
                />
                <span class=" responsive-title-6 font-semibold">
                  {{ t(item.title) }}
                </span>
                <span class="responsive-body-medium ">
                  {{ t(item.body) }}
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <!-- Mobile Version -->
    <div class="flex md:hidden flex-col gap-6">
      <!-- Mobile Why Choose Us Header -->
      <div class="why-choose-row flex justify-center">
        <div class="flex flex-col">
          <div class="cardcolor__title2 w-10/12">
            <div class="responsive-title-2 section-title__header">
              {{ t('whyChoose.header') }}
            </div>
            <p class="cardcolor__title-body pt-6 responsive-body-medium">
              {{ t('whyChoose.body') }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex gap-10 whyScroll pt-6">
        
        <div class="flex flex-col h-full">
          <div class="cardcolor h-full flex flex-col">
            <div class="flex">
              <span class="bg-white spanNumber absolute top-0">01</span>
            </div>

            <div
                class="p-7.5 bg-primary-green why-bg-mask whychoose-cards-m  content-center textPlaceholder"
            >
              <img
                  src="@/assets/home/svg/direction.svg"
                  alt="image"
                  class="imagePlaceholder"
              />
              <div class="flex flex-col ">
                <span class="responsive-title-5 font-semibold cardcolor__title mt-3 mb-3">{{ t('whyChoose.integrity.title') }}</span>
              </div>
                <span class=" responsive-body-medium mt-auto cardcolor__body">{{ t('whyChoose.integrity.body') }}</span>
              
            </div>
          </div>
        </div>

        <div class="flex flex-col">
          <div class="cardcolor">
            <div class="flex">
              <span class="bg-white spanNumber absolute top-0">02</span>
            </div>

            <div
                class="p-7.5 bg-primary-ciel why-bg-mask whychoose-cards-m content-center textPlaceholder"
            >
              <img
                  src="@/assets/home/svg/customer.svg"
                  alt="image"
                  class="imagePlaceholder"
              />
              <div class="flex flex-col mt-1.5">
                <span class="responsive-title-6 font-semibold cardcolor__title mt-3 mb-3">{{
                    t('whyChoose.customerCentricity.title')
                  }}</span>
                <span class=" responsive-body-medium mt-1.5 cardcolor__body">{{ t('whyChoose.customerCentricity.body') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col">
          <div class="cardcolor">
            <div class="flex">
              <span class="bg-white spanNumber absolute top-0">03</span>
            </div>
            <div
                class="p-7.5 bg-primary-yellow why-bg-mask whychoose-cards-m content-center textPlaceholder"
            >
              <img
                  src="@/assets/home/svg/loyalty.svg"
                  alt="image"
                  class="imagePlaceholder"
              />
              <div class="flex flex-col mt-1.5">
                <span class="responsive-title-6 font-semibold cardcolor__title mt-3 mb-3">{{ t('whyChoose.loyalty.title') }}</span>
                <span class=" responsive-body-medium mt-1.5 cardcolor__body">{{ t('whyChoose.loyalty.body') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col">
          <div class="cardcolor">
            <div class="flex">
              <span class="bg-white spanNumber absolute top-0">04</span>
            </div>

            <div
                class="p-7.5 bg-primary-mouve why-bg-mask whychoose-cards-m content-center textPlaceholder"
            >
              <img
                  src="@/assets/home/svg/reliability.svg"
                  alt="image"
                  class="imagePlaceholder"
              />
              <div class="flex flex-col mt-1.5">
                <span class="responsive-title-6 font-semibold cardcolor__title mt-3 mb-3">{{
                    t('whyChoose.reliability.title')
                  }}</span>
                <span class=" responsive-body-medium mt-1.5 cardcolor__body">{{ t('whyChoose.reliability.body') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { getAsset } from "@/helpers/assetsUtils";

const { t } = useI18n();

const whyChooseItems = [
  {
    id: 1,
    title: "whyChoose.integrity.title",
    body: "whyChoose.integrity.body",
    icon: getAsset('homeSvg', 'direction.svg'),
    gridClass: "integrity-row flex justify-center",
    cardClass: "p-7.5 bg-primary-green why-bg-mask whychoose-cards content-end textPlaceholder",
  },
  {
    id: 2,
    title: "whyChoose.customerCentricity.title",
    body: "whyChoose.customerCentricity.body",
    icon: getAsset('homeSvg', 'customer.svg'),
    gridClass: "custom-centri-row flex justify-center",
    cardClass: "p-7.5 bg-primary-ciel why-bg-mask whychoose-cards content-end textPlaceholder",
  },
  {
    id: 3,
    title: "whyChoose.loyalty.title",
    body: "whyChoose.loyalty.body",
    icon: getAsset('homeSvg', 'loyalty.svg'),
    gridClass: "loyalty-row flex justify-center",
    cardClass: "p-7.5 bg-primary-yellow why-bg-mask whychoose-cards content-end textPlaceholder",
  },
  {
    id: 4,
    title: "whyChoose.reliability.title",
    body: "whyChoose.reliability.body",
    icon: getAsset('homeSvg', 'reliability.svg'),
    gridClass: "reliability-row flex justify-center",
    cardClass: "p-7.5 bg-primary-mouve why-bg-mask whychoose-cards content-end textPlaceholder",
  },
];
</script>


<style scoped>
.need-help__crew-imgs img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 3px solid white;
}

.need-help__crew-imgs img:not(:first-child) {
  margin-left: -15px !important;
}

.thirddiv-join__cta .tag-pills div {
  height: 30px;
}

.news {
  min-width: 200px;
}

.whiteChip {
  border: 1px solid white;
  padding: 2px 4px;
  border-radius: 30px;
  font-size: 14px;
}

.textPlaceholder {
  border-radius: 0px 0px 10px 10px;
}

.whitespace {
  height: inherit;
}

.placeholderY {
  border-radius: 10px 0px 0px 0px;
  height: 35px;
}

.placeholderX {
  width: -webkit-fill-available;
  border-radius: 10px 10px 0px 0px;
}

.cardcolor {
  width: 20vw;
  height: 18vw;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.cardcolor.cardcolor__title {
  height: 100%;
}

.spanNumber {
  font-weight: 600;
  font-size: 20px;
}

.why-bg-mask {
  mask-image: url("@/assets/images/mask/mask.svg");
  mask-repeat: no-repeat;
  mask-size: cover;
}

.whychoose-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-template-rows: inherit;
}

.whychoose-cards {
  height: 18vw;
  max-width: 19vw;
  border-radius: 10px;
}

.cardcolor__title {
  width: 19vw;
}

.integrity-row {
  grid-area: 2 / 1 / 4 / 2;
}

.why-choose-row {
  grid-area: 1 / 2 / 3 / 3;
}

.custom-centri-row {
  grid-area: 3 / 2 / 5 / 3;
}

.loyalty-row {
  grid-area: 2 / 3 / 4 / 4;
}

.reliability-row {
  grid-area: 3 / 4 / 5 / 5;
}

.imageCol {
  width: 100%;
  height: 265px;
  object-fit: cover;
}

.landingImage {
  background-image: url("@/assets/home/new/home pant.png");
  background-size: cover;
  background-position: center;
  max-height: 650px;
  height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}

.semibold {
  font-weight: 600;
  color: #b7b6be;
}

.textBGgreen {
  color: #8c8b94;
}

.circle {
  width: fit-content;
  border: 1px solid black;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}

.easyText {
  color: #1b84ff;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
}

.grid-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 200px;
}

.grid-item.large {
  grid-column: span 2;
}

.grid-item img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure images cover the item area */
}

.grid-item .content {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: white;
  padding: 10px;
  border-radius: 4px;
}

.newsOverflow {
  overflow-x: scroll;
  gap: 20px;
  display: flex;
  width: 90vw;
}

.textboxContainer .textbox {
  width: 400px;
}

@media (min-width: 1679px) {
  .imagePlaceholder {
    height: 65px;
  }
}

@media (max-width: 1678px) {
  .landingImage .booking__title {
    width: 50%;
  }

  .thirddiv {
    row-gap: 40px;
  }

  .thirddiv .need-help {
    row-gap: 25px;
  }

  .thirddiv .textbox__title {
    font-size: 16px;
  }

  .thirddiv .textbox__subtitle {
    font-size: 14px;
  }

  .thirddiv .thirddiv-join__cta h2 {
    font-size: 40px !important;
  }

  .textboxContainer .textbox {
    width: 20vw;
  }

}


  .whychoose-cards {
    height: 21vw;
    max-width: 22vw;
  }

  .loyalty-row .imagePlaceholder {
    width: 3vw;
  }

  .custom-centri-row .imagePlaceholder {
    width: 5vw;
  }

  .integrity-row .imagePlaceholder {
    width: 4vw;
  }

  .reliability-row .imagePlaceholder {
    width: 6vw;
  }

  .whychoose-grid .spanNumber {
    font-size: 18px;
  }

  .whychoose-grid .cardcolor__text {
    font-size: 14px;
  }


@media (max-width: 1440px) and (min-width: 1025px) {
  
  .need-help__crew-imgs img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid white;
  }

  .cardcolor {
    width: 22vw;
    height: 21vw;
  }
  
}

@media (max-width: 1350px) {
  

  .cardcolor.cardcolor__title {
    height: 300px !important;
  }


  .travel-inspirations__grid.mobile-travel img {
    width: 30vw;
  }
}

@media (max-width: 1269px) {
  .whychoose-cards {
    height: 30vw;
  }
}

@media (max-width: 1155px) and (min-width: 581px) {
  .landingImage .booking__title {
    width: 70%;
  }
  
  .thirddiv .textboxContainer {
    gap: 30px;
  }
  
}



@media (max-width: 1023px) {
  .whyScroll {
    overflow-x: scroll;
    gap: 20px;
    display: flex;
  }
  
  .whyScroll .whychoose-cards-m {
    height: 100%;
  }

  .whyScroll .whychoose-cards {
    height: 100%;
  }

  .cardcolor {
    min-width: 320px;
    height: 300px;
    position: relative;
  }
  
}

@media (max-width: 768px) {
  
  .landingImage .booking__title {
    width: 85%;

  }

  .seconddiv img {
    width: 45px;
  }
  
  .curatedContainer .grid-container {
    display: flex !important;
    overflow-x: scroll;
  }

  .curatedContainer .grid-item {
    min-width: 260px;
    height: 300px;
  }
  

  .charterContainer > div > div {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  

  .bluediv > div {
    flex-direction: column;
    gap: 20px;
    padding: 30px 20px;
    height: 100%;
  }
    

  .textbox > .font-bold {
    font-size: 14px;
  }

  .textbox > .textBGgreen {
    font-size: 12px;
    width: 150px;
  }

}

@media (min-width: 1155px) {

}

@media (max-width: 580px) {
  .landingImage .booking__subtitle {
    display: none;
  }
  

  .seconddiv .icon-box {
    flex-direction: row;
    justify-content: unset !important;
    align-items: center;
    width: 100%;
    column-gap: 2rem;
  }
  

  .textbox .textbox__title {
    font-size: 16px !important;
  }

  .textbox .textbox__subtitle {
    font-size: 14px !important;
  }
  
}
</style>